module.exports = __webpack_public_path__ + "img/bg-shippo-l.a7cdc4dc.svg";